import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { IStockProduct } from "../types";
import { ColumnType } from "antd/lib/table";
import { ApiStatuses } from "../../../app/types";
import { LMTable } from "../../../components/LMTable";
import { ProductPhotoCell } from "../../../components";
import { getTranslation } from "../../i18n";
// import { LMNewButton } from "../../../components/LMNewButton";
// import { IconExport } from "../../../assets";

interface Props {
  stockProducts: IStockProduct[];
  status: ApiStatuses;
  onExport: () => void;
}

export const SystemProductsList: FC<Props> = ({
  stockProducts,
  status,
  //onExport,
}) => {
  const { t } = useTranslation("system");

  const columns = useMemo(
    () => [
      {
        title: t("name"),
        key: "name",
        render: (stockProduct: IStockProduct) => {
          return (
            <ProductPhotoCell
              name={getTranslation(stockProduct.product.name) || ""}
              image={stockProduct.product.primaryImageUrl}
            />
          );
        },
        sorter: true,
      },
      {
        title: t("identifier"),
        key: "identifier",
        render: (stockProduct: IStockProduct) => {
          return (
            <div>
              {stockProduct.product.identifiers.map((identifier) => (
                <div key={identifier.value}>
                  {identifier.type}: {identifier.value}
                </div>
              ))}
            </div>
          );
        },
      },
      {
        title: t("totalQuantity"),
        key: "totalQuantity",
        dataIndex: "total",
      },
      {
        title: t("assignedQuantity"),
        key: "assignedQuantity",
        dataIndex: "assigned",
      },
      {
        title: t("reservedQuantity"),
        key: "reservedQuantity",
        dataIndex: "reserved",
      },
      {
        title: t("availableQuantity"),
        key: "availableQuantity",
        dataIndex: "available",
      },
    ],
    [t]
  ) as ColumnType<IStockProduct>[];

  return (
    <LMTable
      // action={
      //   <LMNewButton
      //     onClick={onExport}
      //     iconRight={<IconExport />}
      //     type="primary"
      //     small
      //   >
      //     {t("export")}
      //   </LMNewButton>
      // }
      loading={status === ApiStatuses.loading}
      columns={columns}
      dataSource={stockProducts}
      rowKey="productId"
      total={{ title: t("total"), amount: stockProducts.length }}
    />
  );
};
